export default {"src":"/_next/static/media/base.500fcf21.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};